import { LayerManager } from '@agm/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HelperService } from 'src/app/helpers/helper.service';
import { PathRoutes } from 'src/app/routes/path-routes';
import { PlanService } from 'src/app/services/plan.service';
import { SessionService } from 'src/app/services/session.service';
import { UsersService } from 'src/app/services/users.service';
declare var pagarme: any;

@Component({
  selector: 'app-register-payment',
  templateUrl: './register-payment.component.html',
  styleUrls: ['./register-payment.component.scss']
})
export class RegisterPaymentComponent implements OnInit {
  PathRoutes = PathRoutes
  form: FormGroup
  loading = false
  termsOfUse: any
  installments = []
  item = {
    amount: '0',
    dependents: 1,
    hasDependents: false,
    installments_index: 0
  }
  filters = {
    dependents: 0
  }
  loadingPrice = false
  card_hash: any
  state: any
  registerForm: any
  session: any
  submitting = false

  constructor(
    public helper: HelperService,
    private formBuilder: FormBuilder,
    private router: Router,
    private sessionService: SessionService,
    private userService: UsersService,
    private planService: PlanService
  ) {
    this.state = this.router.getCurrentNavigation().extras.state
  }

  ngOnInit(): void {
    // this.loading = true
    this.session = this.sessionService.getSession()
    this.registerForm = this.sessionService.getRegister()
    this.setupForm()
    this.getPlan(true)
  }

  grabCardHash() {
    this.submitting = true
    var key = 'ek_test_LbMdFwKTDG1LUdoPZl3iog7GOQTEmS'
    // var key = 'ek_live_S2yJ8T5B4wvKXRzbT3l6NeYexfazA7'
    let params = {
      card_holder_name: this.form.get('card_holder_name').value,
      card_number: this.form.get('card_number').value,
      card_cvv: this.form.get('card_cvv').value,
      card_expiration_date: this.form.get('card_expiration_date').value,
    }
    pagarme.client.connect({ encryption_key: key })
      .then(client => client.security.encrypt(params))
      .then(card_hash => this.card_hash_ok(card_hash))
      .catch(error => console.log('Erro no card hash', error));
  }

  card_hash_ok(card_hash) {
    console.log('card_hash', card_hash)
    this.card_hash = card_hash
    this.register()
  }

  setupForm() {
    this.form = this.formBuilder.group({
      'amount': ['', Validators.required],
      'installments': ['', Validators.required],
      'card_holder_name': ['', Validators.required],
      'card_number': ['', Validators.required],
      'card_expiration_date': ['', Validators.required],
      'card_cvv': ['', Validators.required],
    })
    if (this.registerForm?.plan) {
      this.form.get('installments').setValue(this.registerForm?.plan?.installments)
    }
  }

  addDependent() {
    let value = this.item.dependents + 1
    this.item.dependents = value
    this.filters.dependents = value
    this.getPlan()
  }

  removeDependent() {
    if (this.item.dependents == 1) {
      return
    }
    let value = this.item.dependents - 1
    this.item.dependents = value
    this.filters.dependents = value
    this.getPlan()
  }

  changeHasDependents(v) {
    this.item.dependents = v ? 1 : 0
    this.filters.dependents = v ? 1 : 0
    this.item.hasDependents = v
    this.getPlan()
  }

  async getPlan(first = false) {
    this.loadingPrice = true
    try {
      let res: any = await this.planService.list(this.filters.dependents)
      if (res.status) {
        console.log(res)
        if (first) {
          this.item.amount = Number(this.registerForm?.plan?.amount).toFixed(2).replace('.', ',')
          this.form.get('amount').setValue(this.registerForm?.plan?.amount)
        } else {
          this.item.amount = Number(res.value[this.item.installments_index].total_value).toFixed(2).replace('.', ',')
          this.form.get('amount').setValue(res.value[this.item.installments_index].total_value)
        }
        this.installments = res.value.map((elem, index) => ({
          id: elem.installments,
          name: `${elem.installments}x de R$${Number(elem.value).toFixed(2).replace('.', ',')}`
        }))
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
      this.loadingPrice = false
    }
  }

  changeInstallments(event) {
    console.log(event)
    this.form.get('installments').setValue(event.target.value)
    this.item.installments_index = event.target.options.selectedIndex - 1
    this.getPlan()
  }

  async register() {
    try {
      let creditCardParams = { user_id: this.session.id, card_hash: this.card_hash }
      let creditCard: any = await this.userService.createCreditCard(creditCardParams)
      console.log('RETURN DO CREDIT CARD', creditCard)
      if (creditCard.status) {
        let params = {
          ...this.registerForm.plan,
          ...this.registerForm.info,
          dependents: this.registerForm.dependents,
          card_id: creditCard.data.id,
          userid: this.session.id,
          mobile: this.session.phone,
          associate_card: 0,
          amount: parseFloat(this.registerForm.plan.amount),
          installments: parseInt(this.registerForm.plan.installments)
        }
        console.log('PARAMS', params)
        let res: any = await this.userService.associate(params)
        console.log('RETURN DO ASSOCIATE', res)
        if (res.status == 1) {
          this.router.navigate([PathRoutes.Register.Success])
        } else {
          this.helper.triggerNotification(false, 'Erro', res.message || res.error)
        }
      } else {
        this.helper.triggerNotification(false, 'Erro', creditCard.message || creditCard.error)
      }
    } catch (error) {
      console.log(error)
      this.helper.triggerNotification(false)
    } finally {
      this.submitting = false
    }
  }

}
